/* eslint-disable no-useless-escape */
import React, { FC } from 'react'
import { Button, Box } from '@material-ui/core'

const Congratulations: FC = () => {
  return (
    <div className="signup-layout">
      <div className="signup-header congratulation">
        <img src="/assets/maverick-logo.png" alt="app-logo" className="logo" />
      </div>
      <div className="signup-body congratulation">
        <Box className="title">Congratulations!</Box>
        <Box className="subtitle">You are now cleared to take off on your first mission.</Box>

        <Box className="description">
          Download the app for your system and get ready to meet new customers.
        </Box>

        <div className="button-container">
          <Button
            variant="contained"
            color="primary"
            size="large"
            style={{ marginRight: 20 }}
            href="https://chrome.google.com/webstore/detail/maverick/dimfjlglnagplmcoabjbhoefnljgpbfb?hl=en"
          >
            CHROM EXTENSION
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            href="https://appsource.microsoft.com/en-us/product/office/wa200001835?tab=overview"
          >
            MICROSOFT OUTLOOK
          </Button>
        </div>
      </div>
    </div>
  )
}
export default Congratulations
